let store = {
  namespaced: true,
  state: {
    content: {
      personal: 0,
      interpersonal: 0,
      social: 0,
      overall: 0,
      submitter_name: null,
      relationship: null
    }
  },
  mutations: {
    change (state, value) {
      state.content[value.type] = value.value
    },
    loadValues (state, payload) {
      state.content = {
        ...payload,
        personal: payload.personal * 10,
        interpersonal: payload.interpersonal * 10,
        social: payload.social * 10,
        overall: payload.overall * 10
      }
    },
    resetValues (state) {
      state.content = {
        personal: 0,
        interpersonal: 0,
        social: 0,
        overall: 0,
        submitter_name: null,
        relationship: null
      }
    }
  },
  actions: {
  }
}

export default store



// WEBPACK FOOTER //
// ./src/store/modules/ors.js